var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transaction-insight-popup',{attrs:{"buttons":_vm.buttons,"cashflow-category":_vm.cashflowCategory,"insight":_vm.insight,"insight-popup-explanation":_vm.indentIncomeExplanation,"insight-popup-title":'',"insight-prefix":'הסכום שנכנס',"show-feedback-footer":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }